<dsm-specs-lot-addendum-view [buildSpecId]="buildSpecId()" />
